/**
 * @about
 * This file conatins api end points
 */

const API_BASE_URL = process.env.REACT_APP_API_URL;

// eslint-disable-next-line import/no-anonymous-default-export
export default  {
    LOGIN_USER: API_BASE_URL + "api/login/",
    SIGNUP_USER: API_BASE_URL + "api/sign-up/",
    CUSTOMERS: API_BASE_URL + "api/company-customers/",
    CUSTOMERS_REPORT_PDF: API_BASE_URL + "api/generate-customer-pdf/",
    USERS: API_BASE_URL + "api/users/",
    USERS_DETAILS: API_BASE_URL + "api/user-detail/",
    CHANGE_PASSWORD: API_BASE_URL + "api/change-password/",
    CHANGE_PIN: API_BASE_URL + "api/set-user-pin/",
    COMPANY: API_BASE_URL + "api/company/",
    DASHBOARD: API_BASE_URL + "api/dashboard/",
    VERIFY_PIN: API_BASE_URL + "api/check-pin/",
    UPDATE_TRANSACTION: API_BASE_URL + "api/transactions/",
    USER_TRANSACTIONS: API_BASE_URL + "api/user-transactions-details/",
    CLOSE: API_BASE_URL + "api/close/",
    CUSTOMER_BASIC_DETAILS: API_BASE_URL + "/dashboard/api/v1/custom-user-model/",
    LOAN_DETAILS: API_BASE_URL + "/dashboard/api/v1/user-history-model/",
    CUSTOMER_LIST: API_BASE_URL + "api/users/",
    BOOK_MARK: API_BASE_URL + "api/mark-transaction-date/",
}